export const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

// Per-person surcharge: base × pct / 100 + flat. null when nothing is configured.
export const computeHssAmount = (basePrice, percentage, flatCharge) => {
    const base = parseFloat(basePrice) || 0;
    const pct = parseFloat(percentage) || 0;
    const flat = parseFloat(flatCharge) || 0;
    if (pct <= 0 && flat <= 0) return null;
    return round2((base * pct) / 100 + flat);
};